import { Typography } from '@mui/material';
import EmojiObjectsOutlinedIcon from '@mui/icons-material/EmojiObjectsOutlined';
import { css } from '@emotion/react';
import { colors } from '../../../theme/colors';
import { panelSurfaceCss } from './panelStyles';

const panelCss = css`
  padding: 12px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const titleCss = css`
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: 0.15px;
  color: ${colors.text.main};
`;

const itemListCss = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const itemCss = css`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const iconWrapperCss = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  background: ${colors.secondary[10]};
  padding: 4px;
  flex-shrink: 0;
`;

const itemTextCss = css`
  flex: 1 0 0;
  min-width: 0;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: 0.17px;
  color: ${colors.text.main};
  overflow: hidden;
  text-overflow: ellipsis;
`;

interface HighlightsPanelProps {
  readonly highlights: readonly string[];
}

export function HighlightsPanel({ highlights }: HighlightsPanelProps) {
  return (
    <div css={[panelSurfaceCss, panelCss]}>
      <Typography css={titleCss}>Highlights</Typography>
      <div css={itemListCss}>
        {highlights.map((h) => (
          <div key={h} css={itemCss}>
            <div css={iconWrapperCss}>
              <EmojiObjectsOutlinedIcon sx={{ fontSize: 16, color: colors.secondary[60] }} />
            </div>
            <span css={itemTextCss}>{h}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
